export default {
  isWeixin() {
    return navigator.userAgent.toLowerCase()
      .indexOf('micromessenger') !== -1;
  }
};

